import { useTheme } from "@material-ui/core";
import { ErrorOutline } from "@material-ui/icons";


const ErrorIcon = ({style, ...props}: React.ComponentProps<typeof ErrorOutline>) => {
    const theme = useTheme();
    return (
        <ErrorOutline style={{color: theme.palette.error.main, ...style}} fontSize='small' {...props} />
    )
}

export default ErrorIcon;